import api from './axios';

const customAgentService = {
  /**
   * List all custom agents
   */
  async listCustomAgents(params = {}) {
    const { status, limit, offset } = params;
    const response = await api.get('/custom-agents', {
      params: { status, limit, offset }
    });
    return response.data;
  },

  /**
   * Get a specific custom agent
   */
  async getCustomAgent(customAgentId) {
    const response = await api.get(`/custom-agents/${customAgentId}`);
    // Backend returns { status: 'success', data: customAgent }
    // Extract customAgent from response.data.data structure
    const customAgent = response.data?.data || response.data;
    console.log('customAgentService.getCustomAgent response:', { 
      hasData: !!response.data, 
      hasDataData: !!response.data?.data,
      customAgentId: customAgent?.id,
      customAgentName: customAgent?.name 
    });
    return customAgent;
  },

  /**
   * Create a new custom agent
   */
  async createCustomAgent(customAgentData) {
    const response = await api.post('/custom-agents', customAgentData);
    // Handle both response.data.data and response.data structures
    return response.data?.data || response.data;
  },

  /**
   * Update an existing custom agent
   */
  async updateCustomAgent(customAgentId, customAgentData) {
    const response = await api.put(`/custom-agents/${customAgentId}`, customAgentData);
    // Backend returns { status: 'success', data: customAgent }
    // Extract customAgent from response.data.data structure
    const customAgent = response.data?.data || response.data;
    console.log('customAgentService.updateCustomAgent response:', { 
      hasData: !!response.data, 
      hasDataData: !!response.data?.data,
      customAgentId: customAgent?.id,
      customAgentName: customAgent?.name 
    });
    return customAgent;
  },

  /**
   * Delete a custom agent
   */
  async deleteCustomAgent(customAgentId) {
    const response = await api.delete(`/custom-agents/${customAgentId}`);
    return response.data;
  },

  /**
   * Deploy (activate) a custom agent
   */
  async deployCustomAgent(customAgentId) {
    const response = await api.post(`/custom-agents/${customAgentId}/deploy`);
    return response.data;
  },

  /**
   * Pause a custom agent
   */
  async pauseCustomAgent(customAgentId) {
    const response = await api.post(`/custom-agents/${customAgentId}/pause`);
    return response.data;
  },

  /**
   * Test a custom agent with sample data
   */
  async testCustomAgent(customAgentId, triggerData = {}) {
    const response = await api.post(`/custom-agents/${customAgentId}/test`, {
      triggerData
    });
    return response.data;
  },

  /**
   * List executions for a custom agent
   */
  async listExecutions(customAgentId, params = {}) {
    const { status, limit, offset } = params;
    const response = await api.get(`/custom-agents/${customAgentId}/executions`, {
      params: { status, limit, offset }
    });
    return response.data;
  },

  /**
   * Get execution details
   */
  async getExecution(executionId) {
    const response = await api.get(`/custom-agent-executions/${executionId}`);
    return response.data;
  },

  /**
   * Retry a failed execution
   */
  async retryExecution(executionId) {
    const response = await api.post(`/custom-agents/executions/${executionId}/retry`);
    return response.data;
  },

  /**
   * Trigger a buyer intent custom agent
   */
  async triggerBuyerIntent(customAgentId, triggerData = {}) {
    const response = await api.post(`/custom-agents/${customAgentId}/trigger/buyer-intent`, triggerData);
    return response.data;
  },

  /**
   * Trigger a deal health custom agent
   */
  async triggerDealHealth(customAgentId, triggerData = {}) {
    const response = await api.post(`/custom-agents/${customAgentId}/trigger/deal-health`, triggerData);
    return response.data;
  }
};

export default customAgentService;
